module.exports = __webpack_public_path__ + "static/media/about_bg2.b7b0a3d4.jpg";